import { IPropAuthLayout } from "types/auth/authLayout";
import * as React from "react";
import { SupportAuth } from "assets/images";
import { useNavigate } from "react-router-dom";
import { useBrandsConfig } from "utils/v2/BrandsConfig/BrandsConfigContext";

const AuthLayoutPc: React.FC<IPropAuthLayout> = ({ children }) => {
  const { logo } = useBrandsConfig();
  const divScroll = React.useRef<any>(null);

  const navigate = useNavigate();

  const openSupportCallHandler = () => {
    navigate("/contact-us");
  };

  return (
    <div ref={divScroll} className="authLayoutPc">
      <div className="authLayoutContainerPC scrollbar-div">{children}</div>
      <div className="authImageContainerPc">
        <img className="logoImgPc" src={logo} alt="logoImg" />
        <img
          className="icon-supportCallPcAuth"
          src={SupportAuth}
          alt="supportCall"
          onClick={openSupportCallHandler}
        />
      </div>
    </div>
  );
};

export default AuthLayoutPc;
